/* unplugin-vue-components disabled */import { render } from "./feed-filters.vue?vue&type=template&id=ebb8135a&scoped=true"
import script from "./feed-filters.vue?vue&type=script&lang=js"
export * from "./feed-filters.vue?vue&type=script&lang=js"

import "./feed-filters.vue?vue&type=style&index=0&id=ebb8135a&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebb8135a"],['__file',"src/pages/pulse/feed/feed-filters.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ebb8135a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ebb8135a', __exports__)) {
    api.reload('ebb8135a', __exports__)
  }
  
  module.hot.accept("./feed-filters.vue?vue&type=template&id=ebb8135a&scoped=true", () => {
    api.rerender('ebb8135a', render)
  })

}


export default __exports__